import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

import Config from '@/config'
import { MainScreen, NotFoundScreen } from '@/screens'

import adminRoutes from './routes/admin'
import authRoutes from './routes/auth'

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
    mode: Config.vueRouter.mode,
    base: Config.vueRouter.base,
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    },
    routes: [
        ...authRoutes,
        ...adminRoutes({ auth: true }),
        {
            path: '/',
            name: 'Main',
            component: MainScreen,
            redirect: { name: 'Admin' },
        },
        {
            path: '*',
            name: '404',
            component: NotFoundScreen,
        },
    ],
})

export default router
